var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDirections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.13333 3.94868V14.782M13.1083 6.13201V17.282M1.90833 7.09868V15.207C1.90833 16.7903 3.03333 17.4403 4.39999 16.657L6.35833 15.5403C6.78333 15.2987 7.49166 15.2737 7.93333 15.4987L12.3083 17.6903C12.75 17.907 13.4583 17.8903 13.8833 17.6487L17.4917 15.582C17.95 15.3153 18.3333 14.6653 18.3333 14.132V6.02368C18.3333 4.44035 17.2083 3.79035 15.8417 4.57368L13.8833 5.69035C13.4583 5.93201 12.75 5.95701 12.3083 5.73201L7.93333 3.54868C7.49166 3.33201 6.78333 3.34868 6.35833 3.59035L2.74999 5.65701C2.28333 5.92368 1.90833 6.57368 1.90833 7.09868Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDirections);
export default __webpack_public_path__ + "static/media/icon-directions.8355d5c69cf5a141e99f8b60c33c91a7.svg";
export { ForwardRef as ReactComponent };